





































































import { CreateElement, VNode } from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { SwSlider, SliderChangeSrcOperation } from '../sw-slider';
import { dropdown, SwDropdownUnit, DropdownDirValues } from '../dropdown-dir';
import SwTable from './sw-table.vue';
import {
  PaginationConfig,
} from './types';

const cssPrefix = 'sw-table-pagination';
const i18nPathPrefix = 'libShared.SwTable';

@Component({
  components: {
    SwIcon,
    SwSlider,
  },
  directives: {
    dropdown,
  },
})
export default class SwTablePagination extends SwExtendedVue {
  @Prop({ required: true, type: Object })
  effectivePaginationConfig: PaginationConfig;

  cssPrefix = cssPrefix;
  i18nPathPrefix = i18nPathPrefix;
  showPageSizeDropdown = false;

  get numberInfo(): string {
    // if (!this.effectivePaginationConfig) { return ''; }
    const start = (this.effectivePaginationConfig.pageNumber - 1) * this.effectivePaginationConfig.pageSize;
    const end = Math.min(start + this.effectivePaginationConfig.pageSize, this.effectivePaginationConfig.datasetTotal!);
    const currentStr = this.$t(`${i18nPathPrefix}.paginationNumberInfo.current`, {
      end,
      start: Math.min(start + 1, end),
    })
      .toString();
    const totalStr = this.$tc(`${i18nPathPrefix}.paginationNumberInfo.total`, this.effectivePaginationConfig.datasetTotal);
    return `${currentStr}${totalStr}`;
  }

  get pageSizeInfo(): string {
    if (!this.effectivePaginationConfig) { return ''; }
    return this.$t(`${i18nPathPrefix}.paginationPageSizeInfo`, { count: this.effectivePaginationConfig.pageSize })
      .toString();
  }

  get pageSizeDropdownValue(): DropdownDirValues {
    return {
      withArrow: false,
      placement: this.effectivePaginationConfig && this.effectivePaginationConfig.placement === 'top' ? 'top-end' : 'bottom-end',
      content: this.pageSizeDropdownContentRender,
      visible: this.showPageSizeDropdown,
      onClickOutsidePopper: () => { this.showPageSizeDropdown = false; },
    };
  }

  get pagesCategories(): string[] {
    const cats: string[] = [];

    if (this.effectivePaginationConfig) {
      const totalPages = Math.ceil(this.effectivePaginationConfig.datasetTotal! / this.effectivePaginationConfig.pageSize);
      for (let i = 1; i <= totalPages; i += 1) {
        cats.push(`${i} / ${totalPages}`);
      }
    }

    return cats;
  }

  get pageSliderValue(): string {
    if (!this.effectivePaginationConfig) { return ''; }
    return this.pagesCategories[this.effectivePaginationConfig.pageNumber - 1];
  }

  @Inject()
  claimChangePagination: SwTable['claimChangePagination'];

  pageSizeDropdownContentRender(h: CreateElement): VNode[] {// tslint:disable-line
    const options: VNode[] = [];

    if (this.effectivePaginationConfig) {
      this.effectivePaginationConfig.pageSizeOpts!.forEach((opt) => {
        options.push(
          <SwDropdownUnit nativeOn-click={() => { this.onSelectPageSize(opt); }}>
          { this.$t(`${i18nPathPrefix}.paginationPageSizeInfo`, { count: opt }) }
          </SwDropdownUnit> as VNode,
        );
      });
    }

    return options;
  }

  onClickPageSizeArrow() {
    this.showPageSizeDropdown = !this.showPageSizeDropdown;
  }

  onSelectPageSize(pageSize: number) {
    this.claimChangePagination('page-size', pageSize);
    this.showPageSizeDropdown = false;
  }

  onChangePageNumber(pageNumValue: string, sourceOperation: SliderChangeSrcOperation) {
    const pageNum = Number(pageNumValue.split('/')[0]);
    if (!isNaN(pageNum)) {
      this.claimChangePagination('page-number', pageNum, sourceOperation === 'drag');
    }
  }

  onDragDonePageNumber(pageNumValue: string) {
    const pageNum = Number(pageNumValue.split('/')[0]);
    if (!isNaN(pageNum)) {
      this.claimChangePagination('page-number', pageNum, false);
    }
  }
}
